import {ChangeDetectorRef, Component, HostBinding, OnDestroy} from "@angular/core";
import {FUINavigationService} from "../../navigation/navigation.service";
import {Subscription} from "rxjs";

@Component({
    selector: "fui-canvas-overlay",
    styleUrls: ["./canvas-overlay.component.scss"],
    templateUrl: "./canvas-overlay.component.html",
    host: {
        "[class.active]": "active",
    },
    standalone: false
})
export class FUICanvasOverlayComponent implements OnDestroy {
    public active: boolean = false;
    private subscriptions: Subscription = new Subscription();

    constructor(private navigationService: FUINavigationService,
                private changeDetectorRef: ChangeDetectorRef) {
        this.subscriptions.add(this.navigationService.activeModal$.subscribe((active) => setTimeout(() => {
            this.active = active;
            this.changeDetectorRef.markForCheck();
        })));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
